var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiTrust2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 0H44.9323L14 37.5L29.2453 75H58V0Z",
    fill: "#57697D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V75H29V8.78913L13.179 0H0Z",
    fill: "#728192"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49 8.40763H44.6069L20 4V48.2594L28.7859 66H49V8.40763Z",
    fill: "#EDEFF3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.40763V66H29V4L13.3464 8.40763H9Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 8.33333L40.6112 4V12.6667H29.1943L27 14.8332L29.1943 17H45V8.33333Z",
    fill: "#C0C8D2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4428 12.6667V4L13 8.33333V17H29V12.6667H17.4428Z",
    fill: "#DAE0E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0H28.9263L20 4.5L28.9263 9H45V0Z",
    fill: "#A6B0BD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.7255 21L49.3628 37.4043L42.2745 30.298L33 39.5957L49.3628 56L75 30.298L65.7255 21Z",
    fill: "#1E8AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTrust2);
export default __webpack_public_path__ + "static/media/ai-trust-2.82fec9b2586a3b1638bf96f2fcef266c.svg";
export { ForwardRef as ReactComponent };